<p-table #dt1 [value]="logs" dataKey="Id" [rows]="20" [loading]="loading" [rowHover]="true"
  styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm tw-max-w-[100vw]" [paginator]="true"
   [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]" [totalRecords]="total" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th>Time</th>
      <th>Action</th>
      <th>Business</th>
      <th>User</th>
      <th>Item Type</th>
      <th>CLient Data</th>
      <th>Data</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-log>
    <tr>
      <td>{{log.Timestamp | date: 'short'}}</td>
      <td>{{log.Action}}</td>
      <td>@if(log.BusinessProfile){<brt-business-avatar [businessIs]="log.BusinessId"
          [profile]="log.BusinessProfile" />}</td>
      <td>@if(log.UserProfile){<brt-user-avatar [userIs]="log.UserId" [profile]="log.UserProfile"
          [identity]="log.UserIdentity" />}</td>
      <td>{{log.ItemType}}</td>
      <td>
        <textarea rows="3" [value]="{IP: log.IP, Url: log.Url, UserAgent: log.UserAgent}|json" readonly></textarea>
      </td>
      <td>
        <textarea rows="3" [value]="log.Payload" readonly></textarea>
      </td>
    </tr>
  </ng-template>
</p-table>